import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { formatToEuro } from '../../deals/new/finances/FinancesCalculationList';
import { getValueWithVatCoefficientApplied } from './OverlayDissolveValues.utils';

export enum SumTableEntryType {
  Value,
  Subtraction,
  Addition,
  Sum,
}

interface SumTableEntry {
  label: string;
  value: number;
  type: SumTableEntryType;
  omit?: boolean;
}

export function SumTable({
  entries,
  sx,
  highlight,
  vatCoefficient,
}: {
  entries: SumTableEntry[];
  highlight?: boolean;
  sx?: SxProps<Theme>;
  vatCoefficient?: number;
}) {
  return (
    <Stack
      gap={1}
      sx={highlight ? { backgroundColor: '#2196F34D', p: 1, borderRadius: 4, ...sx } : sx}
    >
      {entries.map((entry, index) => (
        <Stack flexDirection="row" justifyContent="space-between" key={index}>
          <Typography>
            {getLabelPrefix(entry)}
            {entry.label}
          </Typography>
          <Typography>
            {getValuePrefix(entry)}
            {entry.omit
              ? '-'
              : formatToEuro(getValueWithVatCoefficientApplied(entry.value, vatCoefficient ?? 1))}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
function getValuePrefix(entry: SumTableEntry) {
  switch (entry.type) {
    case SumTableEntryType.Subtraction:
      return '-';
    default:
      return '';
  }
}

function getLabelPrefix(entry: SumTableEntry) {
  switch (entry.type) {
    case SumTableEntryType.Subtraction:
      return '- ';
    case SumTableEntryType.Addition:
      return '+ ';
    case SumTableEntryType.Sum:
      return '= ';
    default:
      return '';
  }
}

export function calculateSum(entries: SumTableEntry[]) {
  return entries.reduce((prev, cur) => {
    switch (cur.type) {
      case SumTableEntryType.Subtraction:
        return prev - cur.value;
      default:
        return prev + cur.value;
    }
  }, 0);
}
